export default __webpack_public_path__ + "static/media/imageTum14.1fb6b5c4.jpg";